import { render, staticRenderFns } from "./ImsSearcher.vue?vue&type=template&id=6ddc3ec0&scoped=true"
import script from "./ImsSearcher.vue?vue&type=script&lang=js"
export * from "./ImsSearcher.vue?vue&type=script&lang=js"
import style0 from "./ImsSearcher.vue?vue&type=style&index=0&id=6ddc3ec0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ddc3ec0",
  null
  
)

export default component.exports